import { useEffect } from 'react';

import { useAppContext } from '../state/app-state';

/**
 * Prevents the page from unloading if the trigger condition is met.
 * The message displayed is built into the web browser and can not be customized.
 * But usually something like: "Leave site? Changes you made may not be saved."
 */
export function usePreventPageUnload() {
  const { pageHasUnsavedChanges } = useAppContext();

  useEffect(() => {
    const eventHandler = (event: BeforeUnloadEvent) => {
      if (pageHasUnsavedChanges) {
        event.preventDefault();
        event.returnValue = ''; // For legacy browser compatibility
        return ''; // For legacy browser compatibility
      }
    };

    window.addEventListener('beforeunload', eventHandler);
    return () => window.removeEventListener('beforeunload', eventHandler);
  }, [pageHasUnsavedChanges]);
}
